export const minLength = (minCount: number) => {
  return (value?: string) => {
    if (!value) {
      return null;
    }

    const countCharacters = value.length;

    if (countCharacters < minCount) {
      return `Mínimo de ${minCount} caracteres`;
    }

    return null;
  };
};
